import { CreateAccessTokenRequest } from 'types/access-tokens/access-token-requests'
import * as z from 'zod'

export const createTokenForm: z.ZodSchema<CreateAccessTokenRequest> = z.object({
    name: z.string().min(1, { message: 'TEXT_REQUIRED' }).max(500),
    scopes: z.string().array().nonempty({ message: 'TEXT_REQUIRED' }),
    validUntil: z.string().min(1, { message: 'TEXT_REQUIRED' }),
})
